// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/workflow.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { Subject } from "./identity_pb.js";
import { PaginationRequest, PaginationResponse } from "./pagination_pb.js";
import { AgentCodeContext, AgentExecution_Status_OutputValue, PullRequest } from "./agent_pb.js";

/**
 * @generated from enum gitpod.v1.WorkflowExecutionPhase
 */
export enum WorkflowExecutionPhase {
  /**
   * @generated from enum value: WORKFLOW_EXECUTION_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_PHASE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_PHASE_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_PHASE_STOPPING = 3;
   */
  STOPPING = 3,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_PHASE_STOPPED = 4;
   */
  STOPPED = 4,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_PHASE_DELETING = 5;
   */
  DELETING = 5,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_PHASE_DELETED = 6;
   */
  DELETED = 6,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_PHASE_COMPLETED = 7;
   */
  COMPLETED = 7,
}
// Retrieve enum metadata with: proto3.getEnumType(WorkflowExecutionPhase)
proto3.util.setEnumType(WorkflowExecutionPhase, "gitpod.v1.WorkflowExecutionPhase", [
  { no: 0, name: "WORKFLOW_EXECUTION_PHASE_UNSPECIFIED" },
  { no: 1, name: "WORKFLOW_EXECUTION_PHASE_PENDING" },
  { no: 2, name: "WORKFLOW_EXECUTION_PHASE_RUNNING" },
  { no: 3, name: "WORKFLOW_EXECUTION_PHASE_STOPPING" },
  { no: 4, name: "WORKFLOW_EXECUTION_PHASE_STOPPED" },
  { no: 5, name: "WORKFLOW_EXECUTION_PHASE_DELETING" },
  { no: 6, name: "WORKFLOW_EXECUTION_PHASE_DELETED" },
  { no: 7, name: "WORKFLOW_EXECUTION_PHASE_COMPLETED" },
]);

/**
 * WorkflowExecutionActionPhase defines the phases of workflow execution action.
 *
 * @generated from enum gitpod.v1.WorkflowExecutionActionPhase
 */
export enum WorkflowExecutionActionPhase {
  /**
   * @generated from enum value: WORKFLOW_EXECUTION_ACTION_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_ACTION_PHASE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_ACTION_PHASE_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_ACTION_PHASE_STOPPING = 3;
   */
  STOPPING = 3,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_ACTION_PHASE_STOPPED = 4;
   */
  STOPPED = 4,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_ACTION_PHASE_DELETING = 5;
   */
  DELETING = 5,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_ACTION_PHASE_DELETED = 6;
   */
  DELETED = 6,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_ACTION_PHASE_DONE = 7;
   */
  DONE = 7,
}
// Retrieve enum metadata with: proto3.getEnumType(WorkflowExecutionActionPhase)
proto3.util.setEnumType(WorkflowExecutionActionPhase, "gitpod.v1.WorkflowExecutionActionPhase", [
  { no: 0, name: "WORKFLOW_EXECUTION_ACTION_PHASE_UNSPECIFIED" },
  { no: 1, name: "WORKFLOW_EXECUTION_ACTION_PHASE_PENDING" },
  { no: 2, name: "WORKFLOW_EXECUTION_ACTION_PHASE_RUNNING" },
  { no: 3, name: "WORKFLOW_EXECUTION_ACTION_PHASE_STOPPING" },
  { no: 4, name: "WORKFLOW_EXECUTION_ACTION_PHASE_STOPPED" },
  { no: 5, name: "WORKFLOW_EXECUTION_ACTION_PHASE_DELETING" },
  { no: 6, name: "WORKFLOW_EXECUTION_ACTION_PHASE_DELETED" },
  { no: 7, name: "WORKFLOW_EXECUTION_ACTION_PHASE_DONE" },
]);

/**
 * CreateWorkflowRequest creates a new workflow.
 *
 * @generated from message gitpod.v1.CreateWorkflowRequest
 */
export class CreateWorkflowRequest extends Message<CreateWorkflowRequest> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from field: repeated gitpod.v1.WorkflowTrigger triggers = 3;
   */
  triggers: WorkflowTrigger[] = [];

  /**
   * @generated from field: gitpod.v1.WorkflowAction action = 4;
   */
  action?: WorkflowAction;

  /**
   * @generated from field: gitpod.v1.WorkflowAction report = 5;
   */
  report?: WorkflowAction;

  constructor(data?: PartialMessage<CreateWorkflowRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateWorkflowRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "triggers", kind: "message", T: WorkflowTrigger, repeated: true },
    { no: 4, name: "action", kind: "message", T: WorkflowAction },
    { no: 5, name: "report", kind: "message", T: WorkflowAction },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateWorkflowRequest {
    return new CreateWorkflowRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateWorkflowRequest {
    return new CreateWorkflowRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateWorkflowRequest {
    return new CreateWorkflowRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateWorkflowRequest | PlainMessage<CreateWorkflowRequest> | undefined, b: CreateWorkflowRequest | PlainMessage<CreateWorkflowRequest> | undefined): boolean {
    return proto3.util.equals(CreateWorkflowRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateWorkflowResponse
 */
export class CreateWorkflowResponse extends Message<CreateWorkflowResponse> {
  /**
   * @generated from field: gitpod.v1.Workflow workflow = 1;
   */
  workflow?: Workflow;

  constructor(data?: PartialMessage<CreateWorkflowResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateWorkflowResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow", kind: "message", T: Workflow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateWorkflowResponse {
    return new CreateWorkflowResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateWorkflowResponse {
    return new CreateWorkflowResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateWorkflowResponse {
    return new CreateWorkflowResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateWorkflowResponse | PlainMessage<CreateWorkflowResponse> | undefined, b: CreateWorkflowResponse | PlainMessage<CreateWorkflowResponse> | undefined): boolean {
    return proto3.util.equals(CreateWorkflowResponse, a, b);
  }
}

/**
 * GetWorkflowRequest gets details about a specific workflow.
 *
 * @generated from message gitpod.v1.GetWorkflowRequest
 */
export class GetWorkflowRequest extends Message<GetWorkflowRequest> {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId = "";

  constructor(data?: PartialMessage<GetWorkflowRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetWorkflowRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWorkflowRequest {
    return new GetWorkflowRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWorkflowRequest {
    return new GetWorkflowRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetWorkflowRequest {
    return new GetWorkflowRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetWorkflowRequest | PlainMessage<GetWorkflowRequest> | undefined, b: GetWorkflowRequest | PlainMessage<GetWorkflowRequest> | undefined): boolean {
    return proto3.util.equals(GetWorkflowRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetWorkflowResponse
 */
export class GetWorkflowResponse extends Message<GetWorkflowResponse> {
  /**
   * @generated from field: gitpod.v1.Workflow workflow = 1;
   */
  workflow?: Workflow;

  constructor(data?: PartialMessage<GetWorkflowResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetWorkflowResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow", kind: "message", T: Workflow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWorkflowResponse {
    return new GetWorkflowResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWorkflowResponse {
    return new GetWorkflowResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetWorkflowResponse {
    return new GetWorkflowResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetWorkflowResponse | PlainMessage<GetWorkflowResponse> | undefined, b: GetWorkflowResponse | PlainMessage<GetWorkflowResponse> | undefined): boolean {
    return proto3.util.equals(GetWorkflowResponse, a, b);
  }
}

/**
 * UpdateWorkflowRequest updates a workflow's configuration.
 *
 * @generated from message gitpod.v1.UpdateWorkflowRequest
 */
export class UpdateWorkflowRequest extends Message<UpdateWorkflowRequest> {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId = "";

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: repeated gitpod.v1.WorkflowTrigger triggers = 4;
   */
  triggers: WorkflowTrigger[] = [];

  /**
   * @generated from field: optional gitpod.v1.WorkflowAction action = 5;
   */
  action?: WorkflowAction;

  /**
   * @generated from field: optional gitpod.v1.WorkflowAction report = 6;
   */
  report?: WorkflowAction;

  /**
   * @generated from field: optional gitpod.v1.Subject executor = 7;
   */
  executor?: Subject;

  constructor(data?: PartialMessage<UpdateWorkflowRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateWorkflowRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "triggers", kind: "message", T: WorkflowTrigger, repeated: true },
    { no: 5, name: "action", kind: "message", T: WorkflowAction, opt: true },
    { no: 6, name: "report", kind: "message", T: WorkflowAction, opt: true },
    { no: 7, name: "executor", kind: "message", T: Subject, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateWorkflowRequest {
    return new UpdateWorkflowRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateWorkflowRequest {
    return new UpdateWorkflowRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateWorkflowRequest {
    return new UpdateWorkflowRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateWorkflowRequest | PlainMessage<UpdateWorkflowRequest> | undefined, b: UpdateWorkflowRequest | PlainMessage<UpdateWorkflowRequest> | undefined): boolean {
    return proto3.util.equals(UpdateWorkflowRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateWorkflowResponse
 */
export class UpdateWorkflowResponse extends Message<UpdateWorkflowResponse> {
  /**
   * @generated from field: gitpod.v1.Workflow workflow = 1;
   */
  workflow?: Workflow;

  constructor(data?: PartialMessage<UpdateWorkflowResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateWorkflowResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow", kind: "message", T: Workflow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateWorkflowResponse {
    return new UpdateWorkflowResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateWorkflowResponse {
    return new UpdateWorkflowResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateWorkflowResponse {
    return new UpdateWorkflowResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateWorkflowResponse | PlainMessage<UpdateWorkflowResponse> | undefined, b: UpdateWorkflowResponse | PlainMessage<UpdateWorkflowResponse> | undefined): boolean {
    return proto3.util.equals(UpdateWorkflowResponse, a, b);
  }
}

/**
 * ListWorkflowsRequest lists workflows with optional filtering.
 *
 * @generated from message gitpod.v1.ListWorkflowsRequest
 */
export class ListWorkflowsRequest extends Message<ListWorkflowsRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListWorkflowsRequest.Filter filter = 2;
   */
  filter?: ListWorkflowsRequest_Filter;

  constructor(data?: PartialMessage<ListWorkflowsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWorkflowsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "filter", kind: "message", T: ListWorkflowsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWorkflowsRequest {
    return new ListWorkflowsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkflowsRequest {
    return new ListWorkflowsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWorkflowsRequest {
    return new ListWorkflowsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListWorkflowsRequest | PlainMessage<ListWorkflowsRequest> | undefined, b: ListWorkflowsRequest | PlainMessage<ListWorkflowsRequest> | undefined): boolean {
    return proto3.util.equals(ListWorkflowsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListWorkflowsRequest.Filter
 */
export class ListWorkflowsRequest_Filter extends Message<ListWorkflowsRequest_Filter> {
  /**
   * @generated from field: repeated string workflow_ids = 1;
   */
  workflowIds: string[] = [];

  constructor(data?: PartialMessage<ListWorkflowsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWorkflowsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWorkflowsRequest_Filter {
    return new ListWorkflowsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkflowsRequest_Filter {
    return new ListWorkflowsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWorkflowsRequest_Filter {
    return new ListWorkflowsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListWorkflowsRequest_Filter | PlainMessage<ListWorkflowsRequest_Filter> | undefined, b: ListWorkflowsRequest_Filter | PlainMessage<ListWorkflowsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListWorkflowsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListWorkflowsResponse
 */
export class ListWorkflowsResponse extends Message<ListWorkflowsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Workflow workflows = 2;
   */
  workflows: Workflow[] = [];

  constructor(data?: PartialMessage<ListWorkflowsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWorkflowsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "workflows", kind: "message", T: Workflow, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWorkflowsResponse {
    return new ListWorkflowsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkflowsResponse {
    return new ListWorkflowsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWorkflowsResponse {
    return new ListWorkflowsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListWorkflowsResponse | PlainMessage<ListWorkflowsResponse> | undefined, b: ListWorkflowsResponse | PlainMessage<ListWorkflowsResponse> | undefined): boolean {
    return proto3.util.equals(ListWorkflowsResponse, a, b);
  }
}

/**
 * DeleteWorkflowRequest deletes a workflow permanently.
 *
 * @generated from message gitpod.v1.DeleteWorkflowRequest
 */
export class DeleteWorkflowRequest extends Message<DeleteWorkflowRequest> {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId = "";

  /**
   * force indicates whether to immediately delete the workflow and all related resources.
   * When true, performs cascading deletion of:
   * - All workflow executions
   * - All workflow execution actions
   * - All environments created by workflow actions
   * - All agent executions created by workflow actions
   * - The workflow itself
   * When false (default), marks workflow executions for deletion and relies on
   * background reconciliation to clean up resources.
   *
   * @generated from field: bool force = 2;
   */
  force = false;

  constructor(data?: PartialMessage<DeleteWorkflowRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteWorkflowRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "force", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteWorkflowRequest {
    return new DeleteWorkflowRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteWorkflowRequest {
    return new DeleteWorkflowRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteWorkflowRequest {
    return new DeleteWorkflowRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteWorkflowRequest | PlainMessage<DeleteWorkflowRequest> | undefined, b: DeleteWorkflowRequest | PlainMessage<DeleteWorkflowRequest> | undefined): boolean {
    return proto3.util.equals(DeleteWorkflowRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteWorkflowResponse
 */
export class DeleteWorkflowResponse extends Message<DeleteWorkflowResponse> {
  constructor(data?: PartialMessage<DeleteWorkflowResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteWorkflowResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteWorkflowResponse {
    return new DeleteWorkflowResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteWorkflowResponse {
    return new DeleteWorkflowResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteWorkflowResponse {
    return new DeleteWorkflowResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteWorkflowResponse | PlainMessage<DeleteWorkflowResponse> | undefined, b: DeleteWorkflowResponse | PlainMessage<DeleteWorkflowResponse> | undefined): boolean {
    return proto3.util.equals(DeleteWorkflowResponse, a, b);
  }
}

/**
 * GetWorkflowWebhookSecretRequest retrieves the webhook secret for a workflow.
 *
 * @generated from message gitpod.v1.GetWorkflowWebhookSecretRequest
 */
export class GetWorkflowWebhookSecretRequest extends Message<GetWorkflowWebhookSecretRequest> {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId = "";

  constructor(data?: PartialMessage<GetWorkflowWebhookSecretRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetWorkflowWebhookSecretRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWorkflowWebhookSecretRequest {
    return new GetWorkflowWebhookSecretRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWorkflowWebhookSecretRequest {
    return new GetWorkflowWebhookSecretRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetWorkflowWebhookSecretRequest {
    return new GetWorkflowWebhookSecretRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetWorkflowWebhookSecretRequest | PlainMessage<GetWorkflowWebhookSecretRequest> | undefined, b: GetWorkflowWebhookSecretRequest | PlainMessage<GetWorkflowWebhookSecretRequest> | undefined): boolean {
    return proto3.util.equals(GetWorkflowWebhookSecretRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetWorkflowWebhookSecretResponse
 */
export class GetWorkflowWebhookSecretResponse extends Message<GetWorkflowWebhookSecretResponse> {
  /**
   * The decrypted webhook secret
   *
   * @generated from field: string secret = 1;
   */
  secret = "";

  constructor(data?: PartialMessage<GetWorkflowWebhookSecretResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetWorkflowWebhookSecretResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWorkflowWebhookSecretResponse {
    return new GetWorkflowWebhookSecretResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWorkflowWebhookSecretResponse {
    return new GetWorkflowWebhookSecretResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetWorkflowWebhookSecretResponse {
    return new GetWorkflowWebhookSecretResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetWorkflowWebhookSecretResponse | PlainMessage<GetWorkflowWebhookSecretResponse> | undefined, b: GetWorkflowWebhookSecretResponse | PlainMessage<GetWorkflowWebhookSecretResponse> | undefined): boolean {
    return proto3.util.equals(GetWorkflowWebhookSecretResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RotateWorkflowWebhookSecretRequest
 */
export class RotateWorkflowWebhookSecretRequest extends Message<RotateWorkflowWebhookSecretRequest> {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId = "";

  constructor(data?: PartialMessage<RotateWorkflowWebhookSecretRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RotateWorkflowWebhookSecretRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RotateWorkflowWebhookSecretRequest {
    return new RotateWorkflowWebhookSecretRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RotateWorkflowWebhookSecretRequest {
    return new RotateWorkflowWebhookSecretRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RotateWorkflowWebhookSecretRequest {
    return new RotateWorkflowWebhookSecretRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RotateWorkflowWebhookSecretRequest | PlainMessage<RotateWorkflowWebhookSecretRequest> | undefined, b: RotateWorkflowWebhookSecretRequest | PlainMessage<RotateWorkflowWebhookSecretRequest> | undefined): boolean {
    return proto3.util.equals(RotateWorkflowWebhookSecretRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RotateWorkflowWebhookSecretResponse
 */
export class RotateWorkflowWebhookSecretResponse extends Message<RotateWorkflowWebhookSecretResponse> {
  /**
   * The new webhook secret (decrypted)
   *
   * @generated from field: string secret = 1;
   */
  secret = "";

  constructor(data?: PartialMessage<RotateWorkflowWebhookSecretResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RotateWorkflowWebhookSecretResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RotateWorkflowWebhookSecretResponse {
    return new RotateWorkflowWebhookSecretResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RotateWorkflowWebhookSecretResponse {
    return new RotateWorkflowWebhookSecretResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RotateWorkflowWebhookSecretResponse {
    return new RotateWorkflowWebhookSecretResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RotateWorkflowWebhookSecretResponse | PlainMessage<RotateWorkflowWebhookSecretResponse> | undefined, b: RotateWorkflowWebhookSecretResponse | PlainMessage<RotateWorkflowWebhookSecretResponse> | undefined): boolean {
    return proto3.util.equals(RotateWorkflowWebhookSecretResponse, a, b);
  }
}

/**
 * StartWorkflowRequest starts a workflow execution.
 *
 * @generated from message gitpod.v1.StartWorkflowRequest
 */
export class StartWorkflowRequest extends Message<StartWorkflowRequest> {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId = "";

  /**
   * Optional context override for the execution.
   * When provided, replaces the workflow's default trigger context.
   * User must have appropriate permissions on the overridden resources.
   * Supports Projects, Repositories, and Agent context types.
   * FromTrigger context type is not supported for manual overrides.
   *
   * @generated from field: optional gitpod.v1.WorkflowTriggerContext context_override = 2;
   */
  contextOverride?: WorkflowTriggerContext;

  constructor(data?: PartialMessage<StartWorkflowRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.StartWorkflowRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "context_override", kind: "message", T: WorkflowTriggerContext, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartWorkflowRequest {
    return new StartWorkflowRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartWorkflowRequest {
    return new StartWorkflowRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartWorkflowRequest {
    return new StartWorkflowRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StartWorkflowRequest | PlainMessage<StartWorkflowRequest> | undefined, b: StartWorkflowRequest | PlainMessage<StartWorkflowRequest> | undefined): boolean {
    return proto3.util.equals(StartWorkflowRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.StartWorkflowResponse
 */
export class StartWorkflowResponse extends Message<StartWorkflowResponse> {
  /**
   * @generated from field: gitpod.v1.WorkflowExecution workflow_execution = 1;
   */
  workflowExecution?: WorkflowExecution;

  constructor(data?: PartialMessage<StartWorkflowResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.StartWorkflowResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_execution", kind: "message", T: WorkflowExecution },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartWorkflowResponse {
    return new StartWorkflowResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartWorkflowResponse {
    return new StartWorkflowResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartWorkflowResponse {
    return new StartWorkflowResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StartWorkflowResponse | PlainMessage<StartWorkflowResponse> | undefined, b: StartWorkflowResponse | PlainMessage<StartWorkflowResponse> | undefined): boolean {
    return proto3.util.equals(StartWorkflowResponse, a, b);
  }
}

/**
 * ListWorkflowExecutionsRequest lists workflow executions with optional filtering.
 *
 * @generated from message gitpod.v1.ListWorkflowExecutionsRequest
 */
export class ListWorkflowExecutionsRequest extends Message<ListWorkflowExecutionsRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListWorkflowExecutionsRequest.Filter filter = 2;
   */
  filter?: ListWorkflowExecutionsRequest_Filter;

  constructor(data?: PartialMessage<ListWorkflowExecutionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWorkflowExecutionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "filter", kind: "message", T: ListWorkflowExecutionsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWorkflowExecutionsRequest {
    return new ListWorkflowExecutionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkflowExecutionsRequest {
    return new ListWorkflowExecutionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWorkflowExecutionsRequest {
    return new ListWorkflowExecutionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListWorkflowExecutionsRequest | PlainMessage<ListWorkflowExecutionsRequest> | undefined, b: ListWorkflowExecutionsRequest | PlainMessage<ListWorkflowExecutionsRequest> | undefined): boolean {
    return proto3.util.equals(ListWorkflowExecutionsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListWorkflowExecutionsRequest.Filter
 */
export class ListWorkflowExecutionsRequest_Filter extends Message<ListWorkflowExecutionsRequest_Filter> {
  /**
   * @generated from field: repeated string workflow_execution_ids = 1;
   */
  workflowExecutionIds: string[] = [];

  /**
   * @generated from field: repeated string workflow_ids = 2;
   */
  workflowIds: string[] = [];

  /**
   * @generated from field: repeated gitpod.v1.WorkflowExecutionPhase status_phases = 3;
   */
  statusPhases: WorkflowExecutionPhase[] = [];

  /**
   * @generated from field: optional bool has_failed_actions = 4;
   */
  hasFailedActions?: boolean;

  constructor(data?: PartialMessage<ListWorkflowExecutionsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWorkflowExecutionsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_execution_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "workflow_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "status_phases", kind: "enum", T: proto3.getEnumType(WorkflowExecutionPhase), repeated: true },
    { no: 4, name: "has_failed_actions", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWorkflowExecutionsRequest_Filter {
    return new ListWorkflowExecutionsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkflowExecutionsRequest_Filter {
    return new ListWorkflowExecutionsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWorkflowExecutionsRequest_Filter {
    return new ListWorkflowExecutionsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListWorkflowExecutionsRequest_Filter | PlainMessage<ListWorkflowExecutionsRequest_Filter> | undefined, b: ListWorkflowExecutionsRequest_Filter | PlainMessage<ListWorkflowExecutionsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListWorkflowExecutionsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListWorkflowExecutionsResponse
 */
export class ListWorkflowExecutionsResponse extends Message<ListWorkflowExecutionsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.WorkflowExecution workflow_executions = 2;
   */
  workflowExecutions: WorkflowExecution[] = [];

  constructor(data?: PartialMessage<ListWorkflowExecutionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWorkflowExecutionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "workflow_executions", kind: "message", T: WorkflowExecution, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWorkflowExecutionsResponse {
    return new ListWorkflowExecutionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkflowExecutionsResponse {
    return new ListWorkflowExecutionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWorkflowExecutionsResponse {
    return new ListWorkflowExecutionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListWorkflowExecutionsResponse | PlainMessage<ListWorkflowExecutionsResponse> | undefined, b: ListWorkflowExecutionsResponse | PlainMessage<ListWorkflowExecutionsResponse> | undefined): boolean {
    return proto3.util.equals(ListWorkflowExecutionsResponse, a, b);
  }
}

/**
 * GetWorkflowExecutionRequest gets details about a specific workflow execution.
 *
 * @generated from message gitpod.v1.GetWorkflowExecutionRequest
 */
export class GetWorkflowExecutionRequest extends Message<GetWorkflowExecutionRequest> {
  /**
   * @generated from field: string workflow_execution_id = 1;
   */
  workflowExecutionId = "";

  constructor(data?: PartialMessage<GetWorkflowExecutionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetWorkflowExecutionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWorkflowExecutionRequest {
    return new GetWorkflowExecutionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWorkflowExecutionRequest {
    return new GetWorkflowExecutionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetWorkflowExecutionRequest {
    return new GetWorkflowExecutionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetWorkflowExecutionRequest | PlainMessage<GetWorkflowExecutionRequest> | undefined, b: GetWorkflowExecutionRequest | PlainMessage<GetWorkflowExecutionRequest> | undefined): boolean {
    return proto3.util.equals(GetWorkflowExecutionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetWorkflowExecutionResponse
 */
export class GetWorkflowExecutionResponse extends Message<GetWorkflowExecutionResponse> {
  /**
   * @generated from field: gitpod.v1.WorkflowExecution workflow_execution = 1;
   */
  workflowExecution?: WorkflowExecution;

  constructor(data?: PartialMessage<GetWorkflowExecutionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetWorkflowExecutionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_execution", kind: "message", T: WorkflowExecution },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWorkflowExecutionResponse {
    return new GetWorkflowExecutionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWorkflowExecutionResponse {
    return new GetWorkflowExecutionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetWorkflowExecutionResponse {
    return new GetWorkflowExecutionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetWorkflowExecutionResponse | PlainMessage<GetWorkflowExecutionResponse> | undefined, b: GetWorkflowExecutionResponse | PlainMessage<GetWorkflowExecutionResponse> | undefined): boolean {
    return proto3.util.equals(GetWorkflowExecutionResponse, a, b);
  }
}

/**
 * CancelWorkflowExecutionRequest cancels a running workflow execution.
 *
 * @generated from message gitpod.v1.CancelWorkflowExecutionRequest
 */
export class CancelWorkflowExecutionRequest extends Message<CancelWorkflowExecutionRequest> {
  /**
   * @generated from field: string workflow_execution_id = 1;
   */
  workflowExecutionId = "";

  constructor(data?: PartialMessage<CancelWorkflowExecutionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CancelWorkflowExecutionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelWorkflowExecutionRequest {
    return new CancelWorkflowExecutionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelWorkflowExecutionRequest {
    return new CancelWorkflowExecutionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelWorkflowExecutionRequest {
    return new CancelWorkflowExecutionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CancelWorkflowExecutionRequest | PlainMessage<CancelWorkflowExecutionRequest> | undefined, b: CancelWorkflowExecutionRequest | PlainMessage<CancelWorkflowExecutionRequest> | undefined): boolean {
    return proto3.util.equals(CancelWorkflowExecutionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CancelWorkflowExecutionResponse
 */
export class CancelWorkflowExecutionResponse extends Message<CancelWorkflowExecutionResponse> {
  constructor(data?: PartialMessage<CancelWorkflowExecutionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CancelWorkflowExecutionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelWorkflowExecutionResponse {
    return new CancelWorkflowExecutionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelWorkflowExecutionResponse {
    return new CancelWorkflowExecutionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelWorkflowExecutionResponse {
    return new CancelWorkflowExecutionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CancelWorkflowExecutionResponse | PlainMessage<CancelWorkflowExecutionResponse> | undefined, b: CancelWorkflowExecutionResponse | PlainMessage<CancelWorkflowExecutionResponse> | undefined): boolean {
    return proto3.util.equals(CancelWorkflowExecutionResponse, a, b);
  }
}

/**
 * ListWorkflowExecutionActionsRequest lists workflow execution actions with optional filtering.
 *
 * @generated from message gitpod.v1.ListWorkflowExecutionActionsRequest
 */
export class ListWorkflowExecutionActionsRequest extends Message<ListWorkflowExecutionActionsRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListWorkflowExecutionActionsRequest.Filter filter = 2;
   */
  filter?: ListWorkflowExecutionActionsRequest_Filter;

  constructor(data?: PartialMessage<ListWorkflowExecutionActionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWorkflowExecutionActionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "filter", kind: "message", T: ListWorkflowExecutionActionsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWorkflowExecutionActionsRequest {
    return new ListWorkflowExecutionActionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkflowExecutionActionsRequest {
    return new ListWorkflowExecutionActionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWorkflowExecutionActionsRequest {
    return new ListWorkflowExecutionActionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListWorkflowExecutionActionsRequest | PlainMessage<ListWorkflowExecutionActionsRequest> | undefined, b: ListWorkflowExecutionActionsRequest | PlainMessage<ListWorkflowExecutionActionsRequest> | undefined): boolean {
    return proto3.util.equals(ListWorkflowExecutionActionsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListWorkflowExecutionActionsRequest.Filter
 */
export class ListWorkflowExecutionActionsRequest_Filter extends Message<ListWorkflowExecutionActionsRequest_Filter> {
  /**
   * @generated from field: repeated string workflow_execution_action_ids = 1;
   */
  workflowExecutionActionIds: string[] = [];

  /**
   * @generated from field: repeated string workflow_execution_ids = 2;
   */
  workflowExecutionIds: string[] = [];

  /**
   * @generated from field: repeated string workflow_ids = 3;
   */
  workflowIds: string[] = [];

  /**
   * @generated from field: repeated gitpod.v1.WorkflowExecutionActionPhase phases = 4;
   */
  phases: WorkflowExecutionActionPhase[] = [];

  constructor(data?: PartialMessage<ListWorkflowExecutionActionsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWorkflowExecutionActionsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_execution_action_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "workflow_execution_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "workflow_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "phases", kind: "enum", T: proto3.getEnumType(WorkflowExecutionActionPhase), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWorkflowExecutionActionsRequest_Filter {
    return new ListWorkflowExecutionActionsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkflowExecutionActionsRequest_Filter {
    return new ListWorkflowExecutionActionsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWorkflowExecutionActionsRequest_Filter {
    return new ListWorkflowExecutionActionsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListWorkflowExecutionActionsRequest_Filter | PlainMessage<ListWorkflowExecutionActionsRequest_Filter> | undefined, b: ListWorkflowExecutionActionsRequest_Filter | PlainMessage<ListWorkflowExecutionActionsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListWorkflowExecutionActionsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListWorkflowExecutionActionsResponse
 */
export class ListWorkflowExecutionActionsResponse extends Message<ListWorkflowExecutionActionsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.WorkflowExecutionAction workflow_execution_actions = 2;
   */
  workflowExecutionActions: WorkflowExecutionAction[] = [];

  constructor(data?: PartialMessage<ListWorkflowExecutionActionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWorkflowExecutionActionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "workflow_execution_actions", kind: "message", T: WorkflowExecutionAction, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWorkflowExecutionActionsResponse {
    return new ListWorkflowExecutionActionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkflowExecutionActionsResponse {
    return new ListWorkflowExecutionActionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWorkflowExecutionActionsResponse {
    return new ListWorkflowExecutionActionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListWorkflowExecutionActionsResponse | PlainMessage<ListWorkflowExecutionActionsResponse> | undefined, b: ListWorkflowExecutionActionsResponse | PlainMessage<ListWorkflowExecutionActionsResponse> | undefined): boolean {
    return proto3.util.equals(ListWorkflowExecutionActionsResponse, a, b);
  }
}

/**
 * GetWorkflowExecutionActionRequest gets details about a specific workflow execution action.
 *
 * @generated from message gitpod.v1.GetWorkflowExecutionActionRequest
 */
export class GetWorkflowExecutionActionRequest extends Message<GetWorkflowExecutionActionRequest> {
  /**
   * @generated from field: string workflow_execution_action_id = 1;
   */
  workflowExecutionActionId = "";

  constructor(data?: PartialMessage<GetWorkflowExecutionActionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetWorkflowExecutionActionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_execution_action_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWorkflowExecutionActionRequest {
    return new GetWorkflowExecutionActionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWorkflowExecutionActionRequest {
    return new GetWorkflowExecutionActionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetWorkflowExecutionActionRequest {
    return new GetWorkflowExecutionActionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetWorkflowExecutionActionRequest | PlainMessage<GetWorkflowExecutionActionRequest> | undefined, b: GetWorkflowExecutionActionRequest | PlainMessage<GetWorkflowExecutionActionRequest> | undefined): boolean {
    return proto3.util.equals(GetWorkflowExecutionActionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetWorkflowExecutionActionResponse
 */
export class GetWorkflowExecutionActionResponse extends Message<GetWorkflowExecutionActionResponse> {
  /**
   * @generated from field: gitpod.v1.WorkflowExecutionAction workflow_execution_action = 1;
   */
  workflowExecutionAction?: WorkflowExecutionAction;

  constructor(data?: PartialMessage<GetWorkflowExecutionActionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetWorkflowExecutionActionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_execution_action", kind: "message", T: WorkflowExecutionAction },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWorkflowExecutionActionResponse {
    return new GetWorkflowExecutionActionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWorkflowExecutionActionResponse {
    return new GetWorkflowExecutionActionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetWorkflowExecutionActionResponse {
    return new GetWorkflowExecutionActionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetWorkflowExecutionActionResponse | PlainMessage<GetWorkflowExecutionActionResponse> | undefined, b: GetWorkflowExecutionActionResponse | PlainMessage<GetWorkflowExecutionActionResponse> | undefined): boolean {
    return proto3.util.equals(GetWorkflowExecutionActionResponse, a, b);
  }
}

/**
 * CancelWorkflowExecutionActionRequest cancels a running workflow execution action.
 *
 * @generated from message gitpod.v1.CancelWorkflowExecutionActionRequest
 */
export class CancelWorkflowExecutionActionRequest extends Message<CancelWorkflowExecutionActionRequest> {
  /**
   * @generated from field: string workflow_execution_action_id = 1;
   */
  workflowExecutionActionId = "";

  constructor(data?: PartialMessage<CancelWorkflowExecutionActionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CancelWorkflowExecutionActionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_execution_action_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelWorkflowExecutionActionRequest {
    return new CancelWorkflowExecutionActionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelWorkflowExecutionActionRequest {
    return new CancelWorkflowExecutionActionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelWorkflowExecutionActionRequest {
    return new CancelWorkflowExecutionActionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CancelWorkflowExecutionActionRequest | PlainMessage<CancelWorkflowExecutionActionRequest> | undefined, b: CancelWorkflowExecutionActionRequest | PlainMessage<CancelWorkflowExecutionActionRequest> | undefined): boolean {
    return proto3.util.equals(CancelWorkflowExecutionActionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CancelWorkflowExecutionActionResponse
 */
export class CancelWorkflowExecutionActionResponse extends Message<CancelWorkflowExecutionActionResponse> {
  constructor(data?: PartialMessage<CancelWorkflowExecutionActionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CancelWorkflowExecutionActionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelWorkflowExecutionActionResponse {
    return new CancelWorkflowExecutionActionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelWorkflowExecutionActionResponse {
    return new CancelWorkflowExecutionActionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelWorkflowExecutionActionResponse {
    return new CancelWorkflowExecutionActionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CancelWorkflowExecutionActionResponse | PlainMessage<CancelWorkflowExecutionActionResponse> | undefined, b: CancelWorkflowExecutionActionResponse | PlainMessage<CancelWorkflowExecutionActionResponse> | undefined): boolean {
    return proto3.util.equals(CancelWorkflowExecutionActionResponse, a, b);
  }
}

/**
 * Workflow represents a workflow configuration.
 *
 * @generated from message gitpod.v1.Workflow
 */
export class Workflow extends Message<Workflow> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: gitpod.v1.Workflow.Metadata metadata = 2;
   */
  metadata?: Workflow_Metadata;

  /**
   * @generated from field: gitpod.v1.Workflow.Spec spec = 3;
   */
  spec?: Workflow_Spec;

  /**
   * Webhook URL for triggering this workflow via HTTP POST
   * Format: {base_url}/workflows/{workflow_id}/webhooks
   *
   * @generated from field: string webhook_url = 4;
   */
  webhookUrl = "";

  constructor(data?: PartialMessage<Workflow>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Workflow";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: Workflow_Metadata },
    { no: 3, name: "spec", kind: "message", T: Workflow_Spec },
    { no: 4, name: "webhook_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Workflow {
    return new Workflow().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Workflow {
    return new Workflow().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Workflow {
    return new Workflow().fromJsonString(jsonString, options);
  }

  static equals(a: Workflow | PlainMessage<Workflow> | undefined, b: Workflow | PlainMessage<Workflow> | undefined): boolean {
    return proto3.util.equals(Workflow, a, b);
  }
}

/**
 * WorkflowMetadata contains workflow metadata.
 *
 * @generated from message gitpod.v1.Workflow.Metadata
 */
export class Workflow_Metadata extends Message<Workflow_Metadata> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from field: gitpod.v1.Subject creator = 3;
   */
  creator?: Subject;

  /**
   * @generated from field: gitpod.v1.Subject executor = 6;
   */
  executor?: Subject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  constructor(data?: PartialMessage<Workflow_Metadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Workflow.Metadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "creator", kind: "message", T: Subject },
    { no: 6, name: "executor", kind: "message", T: Subject },
    { no: 4, name: "created_at", kind: "message", T: Timestamp },
    { no: 5, name: "updated_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Workflow_Metadata {
    return new Workflow_Metadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Workflow_Metadata {
    return new Workflow_Metadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Workflow_Metadata {
    return new Workflow_Metadata().fromJsonString(jsonString, options);
  }

  static equals(a: Workflow_Metadata | PlainMessage<Workflow_Metadata> | undefined, b: Workflow_Metadata | PlainMessage<Workflow_Metadata> | undefined): boolean {
    return proto3.util.equals(Workflow_Metadata, a, b);
  }
}

/**
 * @generated from message gitpod.v1.Workflow.Spec
 */
export class Workflow_Spec extends Message<Workflow_Spec> {
  /**
   * @generated from field: repeated gitpod.v1.WorkflowTrigger triggers = 3;
   */
  triggers: WorkflowTrigger[] = [];

  /**
   * @generated from field: gitpod.v1.WorkflowAction action = 4;
   */
  action?: WorkflowAction;

  /**
   * @generated from field: gitpod.v1.WorkflowAction report = 5;
   */
  report?: WorkflowAction;

  /**
   * Marks workflow as pending deletion
   *
   * @generated from field: bool deleting = 6;
   */
  deleting = false;

  constructor(data?: PartialMessage<Workflow_Spec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Workflow.Spec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 3, name: "triggers", kind: "message", T: WorkflowTrigger, repeated: true },
    { no: 4, name: "action", kind: "message", T: WorkflowAction },
    { no: 5, name: "report", kind: "message", T: WorkflowAction },
    { no: 6, name: "deleting", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Workflow_Spec {
    return new Workflow_Spec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Workflow_Spec {
    return new Workflow_Spec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Workflow_Spec {
    return new Workflow_Spec().fromJsonString(jsonString, options);
  }

  static equals(a: Workflow_Spec | PlainMessage<Workflow_Spec> | undefined, b: Workflow_Spec | PlainMessage<Workflow_Spec> | undefined): boolean {
    return proto3.util.equals(Workflow_Spec, a, b);
  }
}

/**
 * WorkflowTrigger defines when a workflow should be executed.
 *
 * Each trigger type defines a specific condition that will cause the workflow to execute:
 * - Manual: Triggered explicitly by user action via StartWorkflow RPC
 * - Time: Triggered automatically based on cron schedule
 * - PullRequest: Triggered automatically when specified PR events occur
 *
 * Trigger Semantics:
 * - Each trigger instance can create multiple workflow executions
 * - Multiple triggers of the same workflow can fire simultaneously
 * - Each trigger execution is independent and tracked separately
 * - Triggers are evaluated in the context specified by WorkflowTriggerContext
 *
 * @generated from message gitpod.v1.WorkflowTrigger
 */
export class WorkflowTrigger extends Message<WorkflowTrigger> {
  /**
   * @generated from oneof gitpod.v1.WorkflowTrigger.trigger
   */
  trigger: {
    /**
     * @generated from field: gitpod.v1.WorkflowTrigger.Manual manual = 1;
     */
    value: WorkflowTrigger_Manual;
    case: "manual";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowTrigger.Time time = 2;
     */
    value: WorkflowTrigger_Time;
    case: "time";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowTrigger.PullRequest pull_request = 3;
     */
    value: WorkflowTrigger_PullRequest;
    case: "pullRequest";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * @generated from field: gitpod.v1.WorkflowTriggerContext context = 4;
   */
  context?: WorkflowTriggerContext;

  constructor(data?: PartialMessage<WorkflowTrigger>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowTrigger";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "manual", kind: "message", T: WorkflowTrigger_Manual, oneof: "trigger" },
    { no: 2, name: "time", kind: "message", T: WorkflowTrigger_Time, oneof: "trigger" },
    { no: 3, name: "pull_request", kind: "message", T: WorkflowTrigger_PullRequest, oneof: "trigger" },
    { no: 4, name: "context", kind: "message", T: WorkflowTriggerContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowTrigger {
    return new WorkflowTrigger().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowTrigger {
    return new WorkflowTrigger().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowTrigger {
    return new WorkflowTrigger().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowTrigger | PlainMessage<WorkflowTrigger> | undefined, b: WorkflowTrigger | PlainMessage<WorkflowTrigger> | undefined): boolean {
    return proto3.util.equals(WorkflowTrigger, a, b);
  }
}

/**
 * WorkflowPREvent defines pull request events that can trigger workflows.
 *
 * @generated from enum gitpod.v1.WorkflowTrigger.PullRequestEvent
 */
export enum WorkflowTrigger_PullRequestEvent {
  /**
   * @generated from enum value: PULL_REQUEST_EVENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PULL_REQUEST_EVENT_OPENED = 1;
   */
  OPENED = 1,

  /**
   * @generated from enum value: PULL_REQUEST_EVENT_UPDATED = 2;
   */
  UPDATED = 2,

  /**
   * @generated from enum value: PULL_REQUEST_EVENT_APPROVED = 3;
   */
  APPROVED = 3,

  /**
   * @generated from enum value: PULL_REQUEST_EVENT_MERGED = 4;
   */
  MERGED = 4,

  /**
   * @generated from enum value: PULL_REQUEST_EVENT_CLOSED = 5;
   */
  CLOSED = 5,

  /**
   * @generated from enum value: PULL_REQUEST_EVENT_READY_FOR_REVIEW = 6;
   */
  READY_FOR_REVIEW = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(WorkflowTrigger_PullRequestEvent)
proto3.util.setEnumType(WorkflowTrigger_PullRequestEvent, "gitpod.v1.WorkflowTrigger.PullRequestEvent", [
  { no: 0, name: "PULL_REQUEST_EVENT_UNSPECIFIED" },
  { no: 1, name: "PULL_REQUEST_EVENT_OPENED" },
  { no: 2, name: "PULL_REQUEST_EVENT_UPDATED" },
  { no: 3, name: "PULL_REQUEST_EVENT_APPROVED" },
  { no: 4, name: "PULL_REQUEST_EVENT_MERGED" },
  { no: 5, name: "PULL_REQUEST_EVENT_CLOSED" },
  { no: 6, name: "PULL_REQUEST_EVENT_READY_FOR_REVIEW" },
]);

/**
 * Manual trigger - executed when StartWorkflow RPC is called.
 * No additional configuration needed.
 *
 * @generated from message gitpod.v1.WorkflowTrigger.Manual
 */
export class WorkflowTrigger_Manual extends Message<WorkflowTrigger_Manual> {
  constructor(data?: PartialMessage<WorkflowTrigger_Manual>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowTrigger.Manual";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowTrigger_Manual {
    return new WorkflowTrigger_Manual().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowTrigger_Manual {
    return new WorkflowTrigger_Manual().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowTrigger_Manual {
    return new WorkflowTrigger_Manual().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowTrigger_Manual | PlainMessage<WorkflowTrigger_Manual> | undefined, b: WorkflowTrigger_Manual | PlainMessage<WorkflowTrigger_Manual> | undefined): boolean {
    return proto3.util.equals(WorkflowTrigger_Manual, a, b);
  }
}

/**
 * Time-based trigger - executed automatically based on cron schedule.
 * Uses standard cron expression format (minute hour day month weekday).
 *
 * @generated from message gitpod.v1.WorkflowTrigger.Time
 */
export class WorkflowTrigger_Time extends Message<WorkflowTrigger_Time> {
  /**
   * @generated from field: string cron_expression = 1;
   */
  cronExpression = "";

  constructor(data?: PartialMessage<WorkflowTrigger_Time>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowTrigger.Time";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cron_expression", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowTrigger_Time {
    return new WorkflowTrigger_Time().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowTrigger_Time {
    return new WorkflowTrigger_Time().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowTrigger_Time {
    return new WorkflowTrigger_Time().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowTrigger_Time | PlainMessage<WorkflowTrigger_Time> | undefined, b: WorkflowTrigger_Time | PlainMessage<WorkflowTrigger_Time> | undefined): boolean {
    return proto3.util.equals(WorkflowTrigger_Time, a, b);
  }
}

/**
 * Pull request trigger - executed when specified PR events occur.
 * Only triggers for PRs in repositories matching the trigger context.
 *
 * @generated from message gitpod.v1.WorkflowTrigger.PullRequest
 */
export class WorkflowTrigger_PullRequest extends Message<WorkflowTrigger_PullRequest> {
  /**
   * @generated from field: repeated gitpod.v1.WorkflowTrigger.PullRequestEvent events = 1;
   */
  events: WorkflowTrigger_PullRequestEvent[] = [];

  constructor(data?: PartialMessage<WorkflowTrigger_PullRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowTrigger.PullRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "events", kind: "enum", T: proto3.getEnumType(WorkflowTrigger_PullRequestEvent), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowTrigger_PullRequest {
    return new WorkflowTrigger_PullRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowTrigger_PullRequest {
    return new WorkflowTrigger_PullRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowTrigger_PullRequest {
    return new WorkflowTrigger_PullRequest().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowTrigger_PullRequest | PlainMessage<WorkflowTrigger_PullRequest> | undefined, b: WorkflowTrigger_PullRequest | PlainMessage<WorkflowTrigger_PullRequest> | undefined): boolean {
    return proto3.util.equals(WorkflowTrigger_PullRequest, a, b);
  }
}

/**
 * WorkflowTriggerContext defines the context in which a workflow should run.
 *
 * Context determines where and how the workflow executes:
 * - Projects: Execute in specific project environments
 * - Repositories: Execute in environments created from repository URLs
 * - Agent: Execute in agent-managed environments with custom prompts
 * - FromTrigger: Use context derived from the trigger event (PR-specific)
 *
 * Context Usage by Trigger Type:
 * - Manual: Can use any context type
 * - Time: Typically uses Projects or Repositories context
 * - PullRequest: Can use any context, FromTrigger uses PR repository context
 *
 * @generated from message gitpod.v1.WorkflowTriggerContext
 */
export class WorkflowTriggerContext extends Message<WorkflowTriggerContext> {
  /**
   * @generated from oneof gitpod.v1.WorkflowTriggerContext.context
   */
  context: {
    /**
     * @generated from field: gitpod.v1.WorkflowTriggerContext.Projects projects = 1;
     */
    value: WorkflowTriggerContext_Projects;
    case: "projects";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowTriggerContext.Repositories repositories = 2;
     */
    value: WorkflowTriggerContext_Repositories;
    case: "repositories";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowTriggerContext.Agent agent = 3;
     */
    value: WorkflowTriggerContext_Agent;
    case: "agent";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowTriggerContext.FromTrigger from_trigger = 4;
     */
    value: WorkflowTriggerContext_FromTrigger;
    case: "fromTrigger";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<WorkflowTriggerContext>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowTriggerContext";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "projects", kind: "message", T: WorkflowTriggerContext_Projects, oneof: "context" },
    { no: 2, name: "repositories", kind: "message", T: WorkflowTriggerContext_Repositories, oneof: "context" },
    { no: 3, name: "agent", kind: "message", T: WorkflowTriggerContext_Agent, oneof: "context" },
    { no: 4, name: "from_trigger", kind: "message", T: WorkflowTriggerContext_FromTrigger, oneof: "context" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowTriggerContext {
    return new WorkflowTriggerContext().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowTriggerContext {
    return new WorkflowTriggerContext().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowTriggerContext {
    return new WorkflowTriggerContext().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowTriggerContext | PlainMessage<WorkflowTriggerContext> | undefined, b: WorkflowTriggerContext | PlainMessage<WorkflowTriggerContext> | undefined): boolean {
    return proto3.util.equals(WorkflowTriggerContext, a, b);
  }
}

/**
 * Execute workflow in specific project environments.
 * Creates environments for each specified project.
 *
 * @generated from message gitpod.v1.WorkflowTriggerContext.Projects
 */
export class WorkflowTriggerContext_Projects extends Message<WorkflowTriggerContext_Projects> {
  /**
   * @generated from field: repeated string project_ids = 1;
   */
  projectIds: string[] = [];

  constructor(data?: PartialMessage<WorkflowTriggerContext_Projects>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowTriggerContext.Projects";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowTriggerContext_Projects {
    return new WorkflowTriggerContext_Projects().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowTriggerContext_Projects {
    return new WorkflowTriggerContext_Projects().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowTriggerContext_Projects {
    return new WorkflowTriggerContext_Projects().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowTriggerContext_Projects | PlainMessage<WorkflowTriggerContext_Projects> | undefined, b: WorkflowTriggerContext_Projects | PlainMessage<WorkflowTriggerContext_Projects> | undefined): boolean {
    return proto3.util.equals(WorkflowTriggerContext_Projects, a, b);
  }
}

/**
 * Execute workflow in environments created from repository URLs.
 * Supports both explicit repository URLs and search patterns.
 *
 * @generated from message gitpod.v1.WorkflowTriggerContext.Repositories
 */
export class WorkflowTriggerContext_Repositories extends Message<WorkflowTriggerContext_Repositories> {
  /**
   * @generated from oneof gitpod.v1.WorkflowTriggerContext.Repositories.repository_selector
   */
  repositorySelector: {
    /**
     * @generated from field: gitpod.v1.WorkflowTriggerContext.Repositories.RepositoryURLs repository_urls = 1;
     */
    value: WorkflowTriggerContext_Repositories_RepositoryURLs;
    case: "repositoryUrls";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowTriggerContext.Repositories.RepositorySelector repo_selector = 2;
     */
    value: WorkflowTriggerContext_Repositories_RepositorySelector;
    case: "repoSelector";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * @generated from field: string environment_class_id = 3;
   */
  environmentClassId = "";

  constructor(data?: PartialMessage<WorkflowTriggerContext_Repositories>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowTriggerContext.Repositories";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "repository_urls", kind: "message", T: WorkflowTriggerContext_Repositories_RepositoryURLs, oneof: "repository_selector" },
    { no: 2, name: "repo_selector", kind: "message", T: WorkflowTriggerContext_Repositories_RepositorySelector, oneof: "repository_selector" },
    { no: 3, name: "environment_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowTriggerContext_Repositories {
    return new WorkflowTriggerContext_Repositories().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowTriggerContext_Repositories {
    return new WorkflowTriggerContext_Repositories().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowTriggerContext_Repositories {
    return new WorkflowTriggerContext_Repositories().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowTriggerContext_Repositories | PlainMessage<WorkflowTriggerContext_Repositories> | undefined, b: WorkflowTriggerContext_Repositories | PlainMessage<WorkflowTriggerContext_Repositories> | undefined): boolean {
    return proto3.util.equals(WorkflowTriggerContext_Repositories, a, b);
  }
}

/**
 * RepositoryURLs contains a list of explicit repository URLs.
 * Creates one action per repository URL.
 *
 * @generated from message gitpod.v1.WorkflowTriggerContext.Repositories.RepositoryURLs
 */
export class WorkflowTriggerContext_Repositories_RepositoryURLs extends Message<WorkflowTriggerContext_Repositories_RepositoryURLs> {
  /**
   * @generated from field: repeated string repo_urls = 1;
   */
  repoUrls: string[] = [];

  constructor(data?: PartialMessage<WorkflowTriggerContext_Repositories_RepositoryURLs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowTriggerContext.Repositories.RepositoryURLs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "repo_urls", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowTriggerContext_Repositories_RepositoryURLs {
    return new WorkflowTriggerContext_Repositories_RepositoryURLs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowTriggerContext_Repositories_RepositoryURLs {
    return new WorkflowTriggerContext_Repositories_RepositoryURLs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowTriggerContext_Repositories_RepositoryURLs {
    return new WorkflowTriggerContext_Repositories_RepositoryURLs().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowTriggerContext_Repositories_RepositoryURLs | PlainMessage<WorkflowTriggerContext_Repositories_RepositoryURLs> | undefined, b: WorkflowTriggerContext_Repositories_RepositoryURLs | PlainMessage<WorkflowTriggerContext_Repositories_RepositoryURLs> | undefined): boolean {
    return proto3.util.equals(WorkflowTriggerContext_Repositories_RepositoryURLs, a, b);
  }
}

/**
 * RepositorySelector defines how to select repositories for workflow execution.
 * Combines a search string with an SCM host to identify repositories.
 *
 * @generated from message gitpod.v1.WorkflowTriggerContext.Repositories.RepositorySelector
 */
export class WorkflowTriggerContext_Repositories_RepositorySelector extends Message<WorkflowTriggerContext_Repositories_RepositorySelector> {
  /**
   * Search string to match repositories using SCM-specific search patterns.
   * For GitHub: supports GitHub search syntax (e.g., "org:gitpod-io language:go", "user:octocat stars:>100")
   * For GitLab: supports GitLab search syntax
   * See SCM provider documentation for supported search patterns.
   *
   * @generated from field: string repo_search_string = 1;
   */
  repoSearchString = "";

  /**
   * SCM host where the search should be performed (e.g., "github.com", "gitlab.com")
   *
   * @generated from field: string scm_host = 2;
   */
  scmHost = "";

  constructor(data?: PartialMessage<WorkflowTriggerContext_Repositories_RepositorySelector>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowTriggerContext.Repositories.RepositorySelector";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "repo_search_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "scm_host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowTriggerContext_Repositories_RepositorySelector {
    return new WorkflowTriggerContext_Repositories_RepositorySelector().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowTriggerContext_Repositories_RepositorySelector {
    return new WorkflowTriggerContext_Repositories_RepositorySelector().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowTriggerContext_Repositories_RepositorySelector {
    return new WorkflowTriggerContext_Repositories_RepositorySelector().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowTriggerContext_Repositories_RepositorySelector | PlainMessage<WorkflowTriggerContext_Repositories_RepositorySelector> | undefined, b: WorkflowTriggerContext_Repositories_RepositorySelector | PlainMessage<WorkflowTriggerContext_Repositories_RepositorySelector> | undefined): boolean {
    return proto3.util.equals(WorkflowTriggerContext_Repositories_RepositorySelector, a, b);
  }
}

/**
 * Execute workflow in agent-managed environments.
 * Agent receives the specified prompt and manages execution context.
 *
 * @generated from message gitpod.v1.WorkflowTriggerContext.Agent
 */
export class WorkflowTriggerContext_Agent extends Message<WorkflowTriggerContext_Agent> {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt = "";

  constructor(data?: PartialMessage<WorkflowTriggerContext_Agent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowTriggerContext.Agent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowTriggerContext_Agent {
    return new WorkflowTriggerContext_Agent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowTriggerContext_Agent {
    return new WorkflowTriggerContext_Agent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowTriggerContext_Agent {
    return new WorkflowTriggerContext_Agent().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowTriggerContext_Agent | PlainMessage<WorkflowTriggerContext_Agent> | undefined, b: WorkflowTriggerContext_Agent | PlainMessage<WorkflowTriggerContext_Agent> | undefined): boolean {
    return proto3.util.equals(WorkflowTriggerContext_Agent, a, b);
  }
}

/**
 * Use context derived from the trigger event.
 * Currently only supported for PullRequest triggers - uses PR repository context.
 *
 * @generated from message gitpod.v1.WorkflowTriggerContext.FromTrigger
 */
export class WorkflowTriggerContext_FromTrigger extends Message<WorkflowTriggerContext_FromTrigger> {
  constructor(data?: PartialMessage<WorkflowTriggerContext_FromTrigger>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowTriggerContext.FromTrigger";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowTriggerContext_FromTrigger {
    return new WorkflowTriggerContext_FromTrigger().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowTriggerContext_FromTrigger {
    return new WorkflowTriggerContext_FromTrigger().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowTriggerContext_FromTrigger {
    return new WorkflowTriggerContext_FromTrigger().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowTriggerContext_FromTrigger | PlainMessage<WorkflowTriggerContext_FromTrigger> | undefined, b: WorkflowTriggerContext_FromTrigger | PlainMessage<WorkflowTriggerContext_FromTrigger> | undefined): boolean {
    return proto3.util.equals(WorkflowTriggerContext_FromTrigger, a, b);
  }
}

/**
 * WorkflowAction defines the actions to be executed in a workflow.
 *
 * @generated from message gitpod.v1.WorkflowAction
 */
export class WorkflowAction extends Message<WorkflowAction> {
  /**
   * @generated from field: gitpod.v1.WorkflowAction.Limits limits = 1;
   */
  limits?: WorkflowAction_Limits;

  /**
   * @generated from field: repeated gitpod.v1.WorkflowStep steps = 2;
   */
  steps: WorkflowStep[] = [];

  constructor(data?: PartialMessage<WorkflowAction>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowAction";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "limits", kind: "message", T: WorkflowAction_Limits },
    { no: 2, name: "steps", kind: "message", T: WorkflowStep, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowAction {
    return new WorkflowAction().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowAction {
    return new WorkflowAction().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowAction {
    return new WorkflowAction().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowAction | PlainMessage<WorkflowAction> | undefined, b: WorkflowAction | PlainMessage<WorkflowAction> | undefined): boolean {
    return proto3.util.equals(WorkflowAction, a, b);
  }
}

/**
 * Limits defines execution limits for workflow actions.
 *
 * @generated from message gitpod.v1.WorkflowAction.Limits
 */
export class WorkflowAction_Limits extends Message<WorkflowAction_Limits> {
  /**
   * @generated from field: int32 max_parallel = 1;
   */
  maxParallel = 0;

  /**
   * @generated from field: int32 max_total = 2;
   */
  maxTotal = 0;

  /**
   * @generated from field: gitpod.v1.WorkflowAction.Limits.PerExecution per_execution = 3;
   */
  perExecution?: WorkflowAction_Limits_PerExecution;

  constructor(data?: PartialMessage<WorkflowAction_Limits>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowAction.Limits";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "max_parallel", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "max_total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "per_execution", kind: "message", T: WorkflowAction_Limits_PerExecution },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowAction_Limits {
    return new WorkflowAction_Limits().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowAction_Limits {
    return new WorkflowAction_Limits().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowAction_Limits {
    return new WorkflowAction_Limits().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowAction_Limits | PlainMessage<WorkflowAction_Limits> | undefined, b: WorkflowAction_Limits | PlainMessage<WorkflowAction_Limits> | undefined): boolean {
    return proto3.util.equals(WorkflowAction_Limits, a, b);
  }
}

/**
 * PerExecution defines limits per execution action.
 *
 * @generated from message gitpod.v1.WorkflowAction.Limits.PerExecution
 */
export class WorkflowAction_Limits_PerExecution extends Message<WorkflowAction_Limits_PerExecution> {
  /**
   * Maximum time allowed for a single execution action.
   * Use standard duration format (e.g., "30m" for 30 minutes, "2h" for 2 hours).
   *
   * @generated from field: google.protobuf.Duration max_time = 1;
   */
  maxTime?: Duration;

  constructor(data?: PartialMessage<WorkflowAction_Limits_PerExecution>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowAction.Limits.PerExecution";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "max_time", kind: "message", T: Duration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowAction_Limits_PerExecution {
    return new WorkflowAction_Limits_PerExecution().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowAction_Limits_PerExecution {
    return new WorkflowAction_Limits_PerExecution().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowAction_Limits_PerExecution {
    return new WorkflowAction_Limits_PerExecution().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowAction_Limits_PerExecution | PlainMessage<WorkflowAction_Limits_PerExecution> | undefined, b: WorkflowAction_Limits_PerExecution | PlainMessage<WorkflowAction_Limits_PerExecution> | undefined): boolean {
    return proto3.util.equals(WorkflowAction_Limits_PerExecution, a, b);
  }
}

/**
 * WorkflowStep defines a single step in a workflow action.
 *
 * @generated from message gitpod.v1.WorkflowStep
 */
export class WorkflowStep extends Message<WorkflowStep> {
  /**
   * @generated from oneof gitpod.v1.WorkflowStep.step
   */
  step: {
    /**
     * @generated from field: gitpod.v1.WorkflowStep.Task task = 1;
     */
    value: WorkflowStep_Task;
    case: "task";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowStep.Agent agent = 2;
     */
    value: WorkflowStep_Agent;
    case: "agent";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowStep.PullRequest pull_request = 3;
     */
    value: WorkflowStep_PullRequest;
    case: "pullRequest";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowStep.Report report = 4;
     */
    value: WorkflowStep_Report;
    case: "report";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<WorkflowStep>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowStep";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task", kind: "message", T: WorkflowStep_Task, oneof: "step" },
    { no: 2, name: "agent", kind: "message", T: WorkflowStep_Agent, oneof: "step" },
    { no: 3, name: "pull_request", kind: "message", T: WorkflowStep_PullRequest, oneof: "step" },
    { no: 4, name: "report", kind: "message", T: WorkflowStep_Report, oneof: "step" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowStep {
    return new WorkflowStep().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowStep {
    return new WorkflowStep().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowStep {
    return new WorkflowStep().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowStep | PlainMessage<WorkflowStep> | undefined, b: WorkflowStep | PlainMessage<WorkflowStep> | undefined): boolean {
    return proto3.util.equals(WorkflowStep, a, b);
  }
}

/**
 * WorkflowTaskStep represents a task step that executes a command.
 *
 * @generated from message gitpod.v1.WorkflowStep.Task
 */
export class WorkflowStep_Task extends Message<WorkflowStep_Task> {
  /**
   * @generated from field: string command = 1;
   */
  command = "";

  constructor(data?: PartialMessage<WorkflowStep_Task>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowStep.Task";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "command", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowStep_Task {
    return new WorkflowStep_Task().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowStep_Task {
    return new WorkflowStep_Task().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowStep_Task {
    return new WorkflowStep_Task().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowStep_Task | PlainMessage<WorkflowStep_Task> | undefined, b: WorkflowStep_Task | PlainMessage<WorkflowStep_Task> | undefined): boolean {
    return proto3.util.equals(WorkflowStep_Task, a, b);
  }
}

/**
 * WorkflowAgentStep represents an agent step that executes with a prompt.
 *
 * @generated from message gitpod.v1.WorkflowStep.Agent
 */
export class WorkflowStep_Agent extends Message<WorkflowStep_Agent> {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt = "";

  constructor(data?: PartialMessage<WorkflowStep_Agent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowStep.Agent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowStep_Agent {
    return new WorkflowStep_Agent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowStep_Agent {
    return new WorkflowStep_Agent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowStep_Agent {
    return new WorkflowStep_Agent().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowStep_Agent | PlainMessage<WorkflowStep_Agent> | undefined, b: WorkflowStep_Agent | PlainMessage<WorkflowStep_Agent> | undefined): boolean {
    return proto3.util.equals(WorkflowStep_Agent, a, b);
  }
}

/**
 * WorkflowPullRequestStep represents a pull request creation step.
 *
 * @generated from message gitpod.v1.WorkflowStep.PullRequest
 */
export class WorkflowStep_PullRequest extends Message<WorkflowStep_PullRequest> {
  /**
   * @generated from field: string title = 1;
   */
  title = "";

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from field: string branch = 3;
   */
  branch = "";

  /**
   * @generated from field: bool draft = 4;
   */
  draft = false;

  constructor(data?: PartialMessage<WorkflowStep_PullRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowStep.PullRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "draft", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowStep_PullRequest {
    return new WorkflowStep_PullRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowStep_PullRequest {
    return new WorkflowStep_PullRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowStep_PullRequest {
    return new WorkflowStep_PullRequest().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowStep_PullRequest | PlainMessage<WorkflowStep_PullRequest> | undefined, b: WorkflowStep_PullRequest | PlainMessage<WorkflowStep_PullRequest> | undefined): boolean {
    return proto3.util.equals(WorkflowStep_PullRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.WorkflowStep.Report
 */
export class WorkflowStep_Report extends Message<WorkflowStep_Report> {
  /**
   * @generated from field: repeated gitpod.v1.WorkflowStep.Report.OutputSpec outputs = 1;
   */
  outputs: WorkflowStep_Report_OutputSpec[] = [];

  constructor(data?: PartialMessage<WorkflowStep_Report>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowStep.Report";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "outputs", kind: "message", T: WorkflowStep_Report_OutputSpec, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowStep_Report {
    return new WorkflowStep_Report().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowStep_Report {
    return new WorkflowStep_Report().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowStep_Report {
    return new WorkflowStep_Report().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowStep_Report | PlainMessage<WorkflowStep_Report> | undefined, b: WorkflowStep_Report | PlainMessage<WorkflowStep_Report> | undefined): boolean {
    return proto3.util.equals(WorkflowStep_Report, a, b);
  }
}

/**
 * @generated from message gitpod.v1.WorkflowStep.Report.StringSchema
 */
export class WorkflowStep_Report_StringSchema extends Message<WorkflowStep_Report_StringSchema> {
  /**
   * @generated from field: string pattern = 1;
   */
  pattern = "";

  constructor(data?: PartialMessage<WorkflowStep_Report_StringSchema>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowStep.Report.StringSchema";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pattern", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowStep_Report_StringSchema {
    return new WorkflowStep_Report_StringSchema().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowStep_Report_StringSchema {
    return new WorkflowStep_Report_StringSchema().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowStep_Report_StringSchema {
    return new WorkflowStep_Report_StringSchema().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowStep_Report_StringSchema | PlainMessage<WorkflowStep_Report_StringSchema> | undefined, b: WorkflowStep_Report_StringSchema | PlainMessage<WorkflowStep_Report_StringSchema> | undefined): boolean {
    return proto3.util.equals(WorkflowStep_Report_StringSchema, a, b);
  }
}

/**
 * @generated from message gitpod.v1.WorkflowStep.Report.IntegerSchema
 */
export class WorkflowStep_Report_IntegerSchema extends Message<WorkflowStep_Report_IntegerSchema> {
  /**
   * @generated from field: optional int32 min = 1;
   */
  min?: number;

  /**
   * @generated from field: optional int32 max = 2;
   */
  max?: number;

  constructor(data?: PartialMessage<WorkflowStep_Report_IntegerSchema>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowStep.Report.IntegerSchema";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "min", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 2, name: "max", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowStep_Report_IntegerSchema {
    return new WorkflowStep_Report_IntegerSchema().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowStep_Report_IntegerSchema {
    return new WorkflowStep_Report_IntegerSchema().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowStep_Report_IntegerSchema {
    return new WorkflowStep_Report_IntegerSchema().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowStep_Report_IntegerSchema | PlainMessage<WorkflowStep_Report_IntegerSchema> | undefined, b: WorkflowStep_Report_IntegerSchema | PlainMessage<WorkflowStep_Report_IntegerSchema> | undefined): boolean {
    return proto3.util.equals(WorkflowStep_Report_IntegerSchema, a, b);
  }
}

/**
 * @generated from message gitpod.v1.WorkflowStep.Report.FloatSchema
 */
export class WorkflowStep_Report_FloatSchema extends Message<WorkflowStep_Report_FloatSchema> {
  /**
   * @generated from field: optional float min = 1;
   */
  min?: number;

  /**
   * @generated from field: optional float max = 2;
   */
  max?: number;

  constructor(data?: PartialMessage<WorkflowStep_Report_FloatSchema>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowStep.Report.FloatSchema";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "min", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 2, name: "max", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowStep_Report_FloatSchema {
    return new WorkflowStep_Report_FloatSchema().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowStep_Report_FloatSchema {
    return new WorkflowStep_Report_FloatSchema().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowStep_Report_FloatSchema {
    return new WorkflowStep_Report_FloatSchema().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowStep_Report_FloatSchema | PlainMessage<WorkflowStep_Report_FloatSchema> | undefined, b: WorkflowStep_Report_FloatSchema | PlainMessage<WorkflowStep_Report_FloatSchema> | undefined): boolean {
    return proto3.util.equals(WorkflowStep_Report_FloatSchema, a, b);
  }
}

/**
 * @generated from message gitpod.v1.WorkflowStep.Report.BooleanSchema
 */
export class WorkflowStep_Report_BooleanSchema extends Message<WorkflowStep_Report_BooleanSchema> {
  constructor(data?: PartialMessage<WorkflowStep_Report_BooleanSchema>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowStep.Report.BooleanSchema";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowStep_Report_BooleanSchema {
    return new WorkflowStep_Report_BooleanSchema().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowStep_Report_BooleanSchema {
    return new WorkflowStep_Report_BooleanSchema().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowStep_Report_BooleanSchema {
    return new WorkflowStep_Report_BooleanSchema().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowStep_Report_BooleanSchema | PlainMessage<WorkflowStep_Report_BooleanSchema> | undefined, b: WorkflowStep_Report_BooleanSchema | PlainMessage<WorkflowStep_Report_BooleanSchema> | undefined): boolean {
    return proto3.util.equals(WorkflowStep_Report_BooleanSchema, a, b);
  }
}

/**
 * @generated from message gitpod.v1.WorkflowStep.Report.OutputSpec
 */
export class WorkflowStep_Report_OutputSpec extends Message<WorkflowStep_Report_OutputSpec> {
  /**
   * @generated from field: string title = 1;
   */
  title = "";

  /**
   * @generated from field: string key = 2;
   */
  key = "";

  /**
   * @generated from oneof gitpod.v1.WorkflowStep.Report.OutputSpec.schema
   */
  schema: {
    /**
     * @generated from field: gitpod.v1.WorkflowStep.Report.StringSchema string = 10;
     */
    value: WorkflowStep_Report_StringSchema;
    case: "string";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowStep.Report.IntegerSchema integer = 11;
     */
    value: WorkflowStep_Report_IntegerSchema;
    case: "integer";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowStep.Report.FloatSchema float = 12;
     */
    value: WorkflowStep_Report_FloatSchema;
    case: "float";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowStep.Report.BooleanSchema boolean = 13;
     */
    value: WorkflowStep_Report_BooleanSchema;
    case: "boolean";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * Optional CEL expression that decides if the value is acceptable,
   * e.g. is the test coverage high enough. Has one variable (value), must eval to boolean.
   *
   * @generated from field: optional string acceptance_criteria = 5;
   */
  acceptanceCriteria?: string;

  /**
   * @generated from oneof gitpod.v1.WorkflowStep.Report.OutputSpec.extraction
   */
  extraction: {
    /**
     * @generated from field: string prompt = 20;
     */
    value: string;
    case: "prompt";
  } | {
    /**
     * @generated from field: string command = 21;
     */
    value: string;
    case: "command";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<WorkflowStep_Report_OutputSpec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowStep.Report.OutputSpec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "string", kind: "message", T: WorkflowStep_Report_StringSchema, oneof: "schema" },
    { no: 11, name: "integer", kind: "message", T: WorkflowStep_Report_IntegerSchema, oneof: "schema" },
    { no: 12, name: "float", kind: "message", T: WorkflowStep_Report_FloatSchema, oneof: "schema" },
    { no: 13, name: "boolean", kind: "message", T: WorkflowStep_Report_BooleanSchema, oneof: "schema" },
    { no: 5, name: "acceptance_criteria", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "prompt", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "extraction" },
    { no: 21, name: "command", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "extraction" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowStep_Report_OutputSpec {
    return new WorkflowStep_Report_OutputSpec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowStep_Report_OutputSpec {
    return new WorkflowStep_Report_OutputSpec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowStep_Report_OutputSpec {
    return new WorkflowStep_Report_OutputSpec().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowStep_Report_OutputSpec | PlainMessage<WorkflowStep_Report_OutputSpec> | undefined, b: WorkflowStep_Report_OutputSpec | PlainMessage<WorkflowStep_Report_OutputSpec> | undefined): boolean {
    return proto3.util.equals(WorkflowStep_Report_OutputSpec, a, b);
  }
}

/**
 * WorkflowExecutionTrigger represents a workflow execution trigger instance.
 *
 * @generated from message gitpod.v1.WorkflowExecutionTrigger
 */
export class WorkflowExecutionTrigger extends Message<WorkflowExecutionTrigger> {
  /**
   * @generated from oneof gitpod.v1.WorkflowExecutionTrigger.trigger
   */
  trigger: {
    /**
     * @generated from field: gitpod.v1.WorkflowExecutionTrigger.Manual manual = 1;
     */
    value: WorkflowExecutionTrigger_Manual;
    case: "manual";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowExecutionTrigger.Time time = 2;
     */
    value: WorkflowExecutionTrigger_Time;
    case: "time";
  } | {
    /**
     * @generated from field: gitpod.v1.PullRequest pull_request = 3;
     */
    value: PullRequest;
    case: "pullRequest";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * Context from the workflow trigger - copied at execution time for immutability.
   * This allows the reconciler to create actions without fetching the workflow definition.
   *
   * @generated from field: gitpod.v1.WorkflowTriggerContext context = 4;
   */
  context?: WorkflowTriggerContext;

  constructor(data?: PartialMessage<WorkflowExecutionTrigger>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowExecutionTrigger";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "manual", kind: "message", T: WorkflowExecutionTrigger_Manual, oneof: "trigger" },
    { no: 2, name: "time", kind: "message", T: WorkflowExecutionTrigger_Time, oneof: "trigger" },
    { no: 3, name: "pull_request", kind: "message", T: PullRequest, oneof: "trigger" },
    { no: 4, name: "context", kind: "message", T: WorkflowTriggerContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowExecutionTrigger {
    return new WorkflowExecutionTrigger().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowExecutionTrigger {
    return new WorkflowExecutionTrigger().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowExecutionTrigger {
    return new WorkflowExecutionTrigger().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowExecutionTrigger | PlainMessage<WorkflowExecutionTrigger> | undefined, b: WorkflowExecutionTrigger | PlainMessage<WorkflowExecutionTrigger> | undefined): boolean {
    return proto3.util.equals(WorkflowExecutionTrigger, a, b);
  }
}

/**
 * Manual trigger - empty message since no additional data needed
 *
 * @generated from message gitpod.v1.WorkflowExecutionTrigger.Manual
 */
export class WorkflowExecutionTrigger_Manual extends Message<WorkflowExecutionTrigger_Manual> {
  constructor(data?: PartialMessage<WorkflowExecutionTrigger_Manual>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowExecutionTrigger.Manual";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowExecutionTrigger_Manual {
    return new WorkflowExecutionTrigger_Manual().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowExecutionTrigger_Manual {
    return new WorkflowExecutionTrigger_Manual().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowExecutionTrigger_Manual {
    return new WorkflowExecutionTrigger_Manual().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowExecutionTrigger_Manual | PlainMessage<WorkflowExecutionTrigger_Manual> | undefined, b: WorkflowExecutionTrigger_Manual | PlainMessage<WorkflowExecutionTrigger_Manual> | undefined): boolean {
    return proto3.util.equals(WorkflowExecutionTrigger_Manual, a, b);
  }
}

/**
 * Time trigger - just the timestamp when it was triggered
 *
 * @generated from message gitpod.v1.WorkflowExecutionTrigger.Time
 */
export class WorkflowExecutionTrigger_Time extends Message<WorkflowExecutionTrigger_Time> {
  /**
   * @generated from field: google.protobuf.Timestamp triggered_at = 1;
   */
  triggeredAt?: Timestamp;

  constructor(data?: PartialMessage<WorkflowExecutionTrigger_Time>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowExecutionTrigger.Time";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "triggered_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowExecutionTrigger_Time {
    return new WorkflowExecutionTrigger_Time().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowExecutionTrigger_Time {
    return new WorkflowExecutionTrigger_Time().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowExecutionTrigger_Time {
    return new WorkflowExecutionTrigger_Time().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowExecutionTrigger_Time | PlainMessage<WorkflowExecutionTrigger_Time> | undefined, b: WorkflowExecutionTrigger_Time | PlainMessage<WorkflowExecutionTrigger_Time> | undefined): boolean {
    return proto3.util.equals(WorkflowExecutionTrigger_Time, a, b);
  }
}

/**
 * WorkflowExecution represents a workflow execution instance.
 *
 * @generated from message gitpod.v1.WorkflowExecution
 */
export class WorkflowExecution extends Message<WorkflowExecution> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: gitpod.v1.WorkflowExecution.Metadata metadata = 2;
   */
  metadata?: WorkflowExecution_Metadata;

  /**
   * @generated from field: gitpod.v1.WorkflowExecution.Spec spec = 3;
   */
  spec?: WorkflowExecution_Spec;

  /**
   * @generated from field: gitpod.v1.WorkflowExecution.Status status = 4;
   */
  status?: WorkflowExecution_Status;

  constructor(data?: PartialMessage<WorkflowExecution>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowExecution";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: WorkflowExecution_Metadata },
    { no: 3, name: "spec", kind: "message", T: WorkflowExecution_Spec },
    { no: 4, name: "status", kind: "message", T: WorkflowExecution_Status },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowExecution {
    return new WorkflowExecution().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowExecution {
    return new WorkflowExecution().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowExecution {
    return new WorkflowExecution().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowExecution | PlainMessage<WorkflowExecution> | undefined, b: WorkflowExecution | PlainMessage<WorkflowExecution> | undefined): boolean {
    return proto3.util.equals(WorkflowExecution, a, b);
  }
}

/**
 * WorkflowExecutionMetadata contains workflow execution metadata.
 *
 * @generated from message gitpod.v1.WorkflowExecution.Metadata
 */
export class WorkflowExecution_Metadata extends Message<WorkflowExecution_Metadata> {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId = "";

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 2;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 3;
   */
  finishedAt?: Timestamp;

  /**
   * @generated from field: gitpod.v1.Subject creator = 4;
   */
  creator?: Subject;

  /**
   * @generated from field: gitpod.v1.Subject executor = 5;
   */
  executor?: Subject;

  constructor(data?: PartialMessage<WorkflowExecution_Metadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowExecution.Metadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "started_at", kind: "message", T: Timestamp },
    { no: 3, name: "finished_at", kind: "message", T: Timestamp },
    { no: 4, name: "creator", kind: "message", T: Subject },
    { no: 5, name: "executor", kind: "message", T: Subject },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowExecution_Metadata {
    return new WorkflowExecution_Metadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowExecution_Metadata {
    return new WorkflowExecution_Metadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowExecution_Metadata {
    return new WorkflowExecution_Metadata().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowExecution_Metadata | PlainMessage<WorkflowExecution_Metadata> | undefined, b: WorkflowExecution_Metadata | PlainMessage<WorkflowExecution_Metadata> | undefined): boolean {
    return proto3.util.equals(WorkflowExecution_Metadata, a, b);
  }
}

/**
 * WorkflowExecutionSpec contains the specification used for this execution.
 *
 * @generated from message gitpod.v1.WorkflowExecution.Spec
 */
export class WorkflowExecution_Spec extends Message<WorkflowExecution_Spec> {
  /**
   * @generated from field: string session = 1;
   */
  session = "";

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionPhase desired_phase = 2;
   */
  desiredPhase = WorkflowExecutionPhase.UNSPECIFIED;

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionTrigger trigger = 3;
   */
  trigger?: WorkflowExecutionTrigger;

  /**
   * @generated from field: gitpod.v1.WorkflowAction action = 4;
   */
  action?: WorkflowAction;

  /**
   * @generated from field: gitpod.v1.WorkflowAction report = 5;
   */
  report?: WorkflowAction;

  constructor(data?: PartialMessage<WorkflowExecution_Spec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowExecution.Spec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "desired_phase", kind: "enum", T: proto3.getEnumType(WorkflowExecutionPhase) },
    { no: 3, name: "trigger", kind: "message", T: WorkflowExecutionTrigger },
    { no: 4, name: "action", kind: "message", T: WorkflowAction },
    { no: 5, name: "report", kind: "message", T: WorkflowAction },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowExecution_Spec {
    return new WorkflowExecution_Spec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowExecution_Spec {
    return new WorkflowExecution_Spec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowExecution_Spec {
    return new WorkflowExecution_Spec().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowExecution_Spec | PlainMessage<WorkflowExecution_Spec> | undefined, b: WorkflowExecution_Spec | PlainMessage<WorkflowExecution_Spec> | undefined): boolean {
    return proto3.util.equals(WorkflowExecution_Spec, a, b);
  }
}

/**
 * WorkflowExecutionStatus contains the current status of a workflow execution.
 *
 * @generated from message gitpod.v1.WorkflowExecution.Status
 */
export class WorkflowExecution_Status extends Message<WorkflowExecution_Status> {
  /**
   * @generated from field: string session = 1;
   */
  session = "";

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionPhase phase = 2;
   */
  phase = WorkflowExecutionPhase.UNSPECIFIED;

  /**
   * @generated from field: int32 pending_action_count = 10;
   */
  pendingActionCount = 0;

  /**
   * @generated from field: int32 running_action_count = 11;
   */
  runningActionCount = 0;

  /**
   * @generated from field: int32 failed_action_count = 12;
   */
  failedActionCount = 0;

  /**
   * @generated from field: int32 done_action_count = 13;
   */
  doneActionCount = 0;

  /**
   * FailureMessage summarises why the workflow execution failed to operate. If this is non-empty
   * the workflow execution has failed to operate and will likely transition to a stopped state.
   *
   * @generated from field: string failure_message = 14;
   */
  failureMessage = "";

  /**
   * WarningMessage summarises why the workflow execution is in a warning state. If this is non-empty
   * the workflow execution is in a warning state and likely does not match the users expectations.
   *
   * @generated from field: string warning_message = 15;
   */
  warningMessage = "";

  constructor(data?: PartialMessage<WorkflowExecution_Status>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowExecution.Status";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "phase", kind: "enum", T: proto3.getEnumType(WorkflowExecutionPhase) },
    { no: 10, name: "pending_action_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "running_action_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "failed_action_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "done_action_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "failure_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "warning_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowExecution_Status {
    return new WorkflowExecution_Status().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowExecution_Status {
    return new WorkflowExecution_Status().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowExecution_Status {
    return new WorkflowExecution_Status().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowExecution_Status | PlainMessage<WorkflowExecution_Status> | undefined, b: WorkflowExecution_Status | PlainMessage<WorkflowExecution_Status> | undefined): boolean {
    return proto3.util.equals(WorkflowExecution_Status, a, b);
  }
}

/**
 * WorkflowExecutionAction represents a workflow execution action instance.
 *
 * @generated from message gitpod.v1.WorkflowExecutionAction
 */
export class WorkflowExecutionAction extends Message<WorkflowExecutionAction> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionAction.Metadata metadata = 2;
   */
  metadata?: WorkflowExecutionAction_Metadata;

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionAction.Spec spec = 3;
   */
  spec?: WorkflowExecutionAction_Spec;

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionAction.Status status = 4;
   */
  status?: WorkflowExecutionAction_Status;

  constructor(data?: PartialMessage<WorkflowExecutionAction>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowExecutionAction";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: WorkflowExecutionAction_Metadata },
    { no: 3, name: "spec", kind: "message", T: WorkflowExecutionAction_Spec },
    { no: 4, name: "status", kind: "message", T: WorkflowExecutionAction_Status },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowExecutionAction {
    return new WorkflowExecutionAction().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowExecutionAction {
    return new WorkflowExecutionAction().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowExecutionAction {
    return new WorkflowExecutionAction().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowExecutionAction | PlainMessage<WorkflowExecutionAction> | undefined, b: WorkflowExecutionAction | PlainMessage<WorkflowExecutionAction> | undefined): boolean {
    return proto3.util.equals(WorkflowExecutionAction, a, b);
  }
}

/**
 * WorkflowExecutionActionMetadata contains workflow execution action metadata.
 *
 * @generated from message gitpod.v1.WorkflowExecutionAction.Metadata
 */
export class WorkflowExecutionAction_Metadata extends Message<WorkflowExecutionAction_Metadata> {
  /**
   * @generated from field: string workflow_execution_id = 1;
   */
  workflowExecutionId = "";

  /**
   * @generated from field: string workflow_id = 2;
   */
  workflowId = "";

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 3;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 4;
   */
  finishedAt?: Timestamp;

  /**
   * Human-readable name for this action based on its context.
   * Examples: "gitpod-io/gitpod-next" for repository context, "My Project" for project context.
   * Will be empty string for actions created before this field was added.
   *
   * @generated from field: string action_name = 5;
   */
  actionName = "";

  constructor(data?: PartialMessage<WorkflowExecutionAction_Metadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowExecutionAction.Metadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workflow_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "started_at", kind: "message", T: Timestamp },
    { no: 4, name: "finished_at", kind: "message", T: Timestamp },
    { no: 5, name: "action_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowExecutionAction_Metadata {
    return new WorkflowExecutionAction_Metadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowExecutionAction_Metadata {
    return new WorkflowExecutionAction_Metadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowExecutionAction_Metadata {
    return new WorkflowExecutionAction_Metadata().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowExecutionAction_Metadata | PlainMessage<WorkflowExecutionAction_Metadata> | undefined, b: WorkflowExecutionAction_Metadata | PlainMessage<WorkflowExecutionAction_Metadata> | undefined): boolean {
    return proto3.util.equals(WorkflowExecutionAction_Metadata, a, b);
  }
}

/**
 * WorkflowExecutionActionSpec contains the specification for this execution action.
 *
 * @generated from message gitpod.v1.WorkflowExecutionAction.Spec
 */
export class WorkflowExecutionAction_Spec extends Message<WorkflowExecutionAction_Spec> {
  /**
   * @generated from field: string session = 1;
   */
  session = "";

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionActionPhase desired_phase = 2;
   */
  desiredPhase = WorkflowExecutionActionPhase.UNSPECIFIED;

  /**
   * Context for the execution action - specifies where and how the action executes.
   * This is resolved from the workflow trigger context and contains the specific
   * project, repository, or agent context for this execution instance.
   *
   * @generated from field: gitpod.v1.AgentCodeContext context = 3;
   */
  context?: AgentCodeContext;

  /**
   * @generated from field: gitpod.v1.WorkflowAction.Limits.PerExecution limits = 4;
   */
  limits?: WorkflowAction_Limits_PerExecution;

  constructor(data?: PartialMessage<WorkflowExecutionAction_Spec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowExecutionAction.Spec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "desired_phase", kind: "enum", T: proto3.getEnumType(WorkflowExecutionActionPhase) },
    { no: 3, name: "context", kind: "message", T: AgentCodeContext },
    { no: 4, name: "limits", kind: "message", T: WorkflowAction_Limits_PerExecution },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowExecutionAction_Spec {
    return new WorkflowExecutionAction_Spec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowExecutionAction_Spec {
    return new WorkflowExecutionAction_Spec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowExecutionAction_Spec {
    return new WorkflowExecutionAction_Spec().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowExecutionAction_Spec | PlainMessage<WorkflowExecutionAction_Spec> | undefined, b: WorkflowExecutionAction_Spec | PlainMessage<WorkflowExecutionAction_Spec> | undefined): boolean {
    return proto3.util.equals(WorkflowExecutionAction_Spec, a, b);
  }
}

/**
 * WorkflowExecutionActionStatus contains the current status of a workflow execution action.
 *
 * @generated from message gitpod.v1.WorkflowExecutionAction.Status
 */
export class WorkflowExecutionAction_Status extends Message<WorkflowExecutionAction_Status> {
  /**
   * @generated from field: string session = 1;
   */
  session = "";

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionActionPhase phase = 2;
   */
  phase = WorkflowExecutionActionPhase.UNSPECIFIED;

  /**
   * Step-level progress tracking
   *
   * @generated from field: repeated gitpod.v1.WorkflowExecutionAction.Status.StepStatus step_statuses = 3;
   */
  stepStatuses: WorkflowExecutionAction_Status_StepStatus[] = [];

  /**
   * @generated from field: string environment_id = 10;
   */
  environmentId = "";

  /**
   * @generated from field: string agent_execution_id = 12;
   */
  agentExecutionId = "";

  /**
   * FailureMessage summarises why the workflow execution action failed to operate. If this is non-empty
   * the workflow execution action has failed to operate and will likely transition to a stopped state.
   *
   * @generated from field: string failure_message = 11;
   */
  failureMessage = "";

  /**
   * WarningMessage summarises why the workflow execution action is in a warning state. If this is non-empty
   * the workflow execution action is in a warning state and likely does not match the users expectations.
   *
   * @generated from field: string warning_message = 13;
   */
  warningMessage = "";

  constructor(data?: PartialMessage<WorkflowExecutionAction_Status>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowExecutionAction.Status";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "phase", kind: "enum", T: proto3.getEnumType(WorkflowExecutionActionPhase) },
    { no: 3, name: "step_statuses", kind: "message", T: WorkflowExecutionAction_Status_StepStatus, repeated: true },
    { no: 10, name: "environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "failure_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "warning_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowExecutionAction_Status {
    return new WorkflowExecutionAction_Status().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowExecutionAction_Status {
    return new WorkflowExecutionAction_Status().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowExecutionAction_Status {
    return new WorkflowExecutionAction_Status().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowExecutionAction_Status | PlainMessage<WorkflowExecutionAction_Status> | undefined, b: WorkflowExecutionAction_Status | PlainMessage<WorkflowExecutionAction_Status> | undefined): boolean {
    return proto3.util.equals(WorkflowExecutionAction_Status, a, b);
  }
}

/**
 * WorkflowExecutionActionStepStatus represents the status of a single step execution.
 *
 * @generated from message gitpod.v1.WorkflowExecutionAction.Status.StepStatus
 */
export class WorkflowExecutionAction_Status_StepStatus extends Message<WorkflowExecutionAction_Status_StepStatus> {
  /**
   * Index of the step in the workflow action steps array
   *
   * @generated from field: int32 step_index = 1;
   */
  stepIndex = 0;

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionAction.Status.StepStatus.StepPhase phase = 2;
   */
  phase = WorkflowExecutionAction_Status_StepStatus_StepPhase.UNSPECIFIED;

  /**
   * @generated from field: string failure_message = 3;
   */
  failureMessage = "";

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 4;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 5;
   */
  finishedAt?: Timestamp;

  /**
   * The step definition captured at execution time for immutability.
   * This ensures the UI shows the correct step even if the workflow definition changes.
   *
   * @generated from field: gitpod.v1.WorkflowStep step = 6;
   */
  step?: WorkflowStep;

  constructor(data?: PartialMessage<WorkflowExecutionAction_Status_StepStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowExecutionAction.Status.StepStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "step_index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "phase", kind: "enum", T: proto3.getEnumType(WorkflowExecutionAction_Status_StepStatus_StepPhase) },
    { no: 3, name: "failure_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "started_at", kind: "message", T: Timestamp },
    { no: 5, name: "finished_at", kind: "message", T: Timestamp },
    { no: 6, name: "step", kind: "message", T: WorkflowStep },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowExecutionAction_Status_StepStatus {
    return new WorkflowExecutionAction_Status_StepStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowExecutionAction_Status_StepStatus {
    return new WorkflowExecutionAction_Status_StepStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowExecutionAction_Status_StepStatus {
    return new WorkflowExecutionAction_Status_StepStatus().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowExecutionAction_Status_StepStatus | PlainMessage<WorkflowExecutionAction_Status_StepStatus> | undefined, b: WorkflowExecutionAction_Status_StepStatus | PlainMessage<WorkflowExecutionAction_Status_StepStatus> | undefined): boolean {
    return proto3.util.equals(WorkflowExecutionAction_Status_StepStatus, a, b);
  }
}

/**
 * @generated from enum gitpod.v1.WorkflowExecutionAction.Status.StepStatus.StepPhase
 */
export enum WorkflowExecutionAction_Status_StepStatus_StepPhase {
  /**
   * @generated from enum value: STEP_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STEP_PHASE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: STEP_PHASE_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: STEP_PHASE_DONE = 3;
   */
  DONE = 3,

  /**
   * @generated from enum value: STEP_PHASE_FAILED = 4;
   */
  FAILED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(WorkflowExecutionAction_Status_StepStatus_StepPhase)
proto3.util.setEnumType(WorkflowExecutionAction_Status_StepStatus_StepPhase, "gitpod.v1.WorkflowExecutionAction.Status.StepStatus.StepPhase", [
  { no: 0, name: "STEP_PHASE_UNSPECIFIED" },
  { no: 1, name: "STEP_PHASE_PENDING" },
  { no: 2, name: "STEP_PHASE_RUNNING" },
  { no: 3, name: "STEP_PHASE_DONE" },
  { no: 4, name: "STEP_PHASE_FAILED" },
]);

/**
 * @generated from message gitpod.v1.ListWorkflowExecutionOutputsRequest
 */
export class ListWorkflowExecutionOutputsRequest extends Message<ListWorkflowExecutionOutputsRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListWorkflowExecutionOutputsRequest.Filter filter = 2;
   */
  filter?: ListWorkflowExecutionOutputsRequest_Filter;

  constructor(data?: PartialMessage<ListWorkflowExecutionOutputsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWorkflowExecutionOutputsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "filter", kind: "message", T: ListWorkflowExecutionOutputsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWorkflowExecutionOutputsRequest {
    return new ListWorkflowExecutionOutputsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkflowExecutionOutputsRequest {
    return new ListWorkflowExecutionOutputsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWorkflowExecutionOutputsRequest {
    return new ListWorkflowExecutionOutputsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListWorkflowExecutionOutputsRequest | PlainMessage<ListWorkflowExecutionOutputsRequest> | undefined, b: ListWorkflowExecutionOutputsRequest | PlainMessage<ListWorkflowExecutionOutputsRequest> | undefined): boolean {
    return proto3.util.equals(ListWorkflowExecutionOutputsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListWorkflowExecutionOutputsRequest.Filter
 */
export class ListWorkflowExecutionOutputsRequest_Filter extends Message<ListWorkflowExecutionOutputsRequest_Filter> {
  /**
   * @generated from field: repeated string workflow_execution_ids = 1;
   */
  workflowExecutionIds: string[] = [];

  constructor(data?: PartialMessage<ListWorkflowExecutionOutputsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWorkflowExecutionOutputsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflow_execution_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWorkflowExecutionOutputsRequest_Filter {
    return new ListWorkflowExecutionOutputsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkflowExecutionOutputsRequest_Filter {
    return new ListWorkflowExecutionOutputsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWorkflowExecutionOutputsRequest_Filter {
    return new ListWorkflowExecutionOutputsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListWorkflowExecutionOutputsRequest_Filter | PlainMessage<ListWorkflowExecutionOutputsRequest_Filter> | undefined, b: ListWorkflowExecutionOutputsRequest_Filter | PlainMessage<ListWorkflowExecutionOutputsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListWorkflowExecutionOutputsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListWorkflowExecutionOutputsResponse
 */
export class ListWorkflowExecutionOutputsResponse extends Message<ListWorkflowExecutionOutputsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.ListWorkflowExecutionOutputsResponse.ActionOutput outputs = 2;
   */
  outputs: ListWorkflowExecutionOutputsResponse_ActionOutput[] = [];

  constructor(data?: PartialMessage<ListWorkflowExecutionOutputsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWorkflowExecutionOutputsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "outputs", kind: "message", T: ListWorkflowExecutionOutputsResponse_ActionOutput, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWorkflowExecutionOutputsResponse {
    return new ListWorkflowExecutionOutputsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkflowExecutionOutputsResponse {
    return new ListWorkflowExecutionOutputsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWorkflowExecutionOutputsResponse {
    return new ListWorkflowExecutionOutputsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListWorkflowExecutionOutputsResponse | PlainMessage<ListWorkflowExecutionOutputsResponse> | undefined, b: ListWorkflowExecutionOutputsResponse | PlainMessage<ListWorkflowExecutionOutputsResponse> | undefined): boolean {
    return proto3.util.equals(ListWorkflowExecutionOutputsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListWorkflowExecutionOutputsResponse.ActionOutput
 */
export class ListWorkflowExecutionOutputsResponse_ActionOutput extends Message<ListWorkflowExecutionOutputsResponse_ActionOutput> {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId = "";

  /**
   * @generated from field: map<string, gitpod.v1.AgentExecution.Status.OutputValue> values = 2;
   */
  values: { [key: string]: AgentExecution_Status_OutputValue } = {};

  constructor(data?: PartialMessage<ListWorkflowExecutionOutputsResponse_ActionOutput>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWorkflowExecutionOutputsResponse.ActionOutput";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "action_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "values", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: AgentExecution_Status_OutputValue} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWorkflowExecutionOutputsResponse_ActionOutput {
    return new ListWorkflowExecutionOutputsResponse_ActionOutput().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkflowExecutionOutputsResponse_ActionOutput {
    return new ListWorkflowExecutionOutputsResponse_ActionOutput().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWorkflowExecutionOutputsResponse_ActionOutput {
    return new ListWorkflowExecutionOutputsResponse_ActionOutput().fromJsonString(jsonString, options);
  }

  static equals(a: ListWorkflowExecutionOutputsResponse_ActionOutput | PlainMessage<ListWorkflowExecutionOutputsResponse_ActionOutput> | undefined, b: ListWorkflowExecutionOutputsResponse_ActionOutput | PlainMessage<ListWorkflowExecutionOutputsResponse_ActionOutput> | undefined): boolean {
    return proto3.util.equals(ListWorkflowExecutionOutputsResponse_ActionOutput, a, b);
  }
}

